import React from "react";
import * as styles from "./bookbox.module.css";
import Book1 from "../../../images/book2.jpg";
import Book2 from "../../../images/book1.png";
import Book3 from "../../../images/js.webp";
import Book5 from "../../../images/html.png";
import Book6 from "../../../images/j2.jpg";

const Bookbox = () => {
  return (
    <div>
      <div className={styles.wrapper}>
        <div className={styles.card}>
          <img src={Book2} alt="book" />
          <div className={styles.descriptions}>
            <h1>REACT.JS</h1>
            <p>
              After gunning down a member of the High Table -- the shadowy
              international assassin's guild -- legendary hit man John Wick
              finds himself stripped of the organization's protective services.
              Now stuck with a $14 million bounty on his head, Wick must fight
              his way through the streets of New York as he becomes the target
              of the world's most ruthless killers.
            </p>
            <div>
              <svg width="0" height="0">
                <filter id="filter">
                  <feTurbulence
                    type="fractalNoise"
                    baseFrequency=".01"
                    numOctaves="6"
                  />
                  <feDisplacementMap in="SourceGraphic" scale="100" />
                </filter>
              </svg>
              <div className={styles.btn4}>
                <div className={styles.button4}>
                  <span>Read More</span>
                  <div className={styles.back}></div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className={styles.card}>
          <img src={Book1} alt="book" />
          <div className={styles.descriptions}>
            <h1>PROGRAMMING</h1>
            <p>
              After gunning down a member of the High Table -- the shadowy
              international assassin's guild -- legendary hit man John Wick
              finds himself stripped of the organization's protective services.
              Now stuck with a $14 million bounty on his head, Wick must fight
              his way through the streets of New York as he becomes the target
              of the world's most ruthless killers.
            </p>
            <div>
              <svg width="0" height="0">
                <filter id="filter">
                  <feTurbulence
                    type="fractalNoise"
                    baseFrequency=".01"
                    numOctaves="6"
                  />
                  <feDisplacementMap in="SourceGraphic" scale="100" />
                </filter>
              </svg>
              <div className={styles.btn4}>
                <div className={styles.button4}>
                  <span>Read More</span>
                  <div className={styles.back}></div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className={styles.card}>
          <img src={Book6} alt="book" />
          <div className={styles.descriptions}>
            <h1>JAVASCRIPT</h1>
            <p>
              After gunning down a member of the High Table -- the shadowy
              international assassin's guild -- legendary hit man John Wick
              finds himself stripped of the organization's protective services.
              Now stuck with a $14 million bounty on his head, Wick must fight
              his way through the streets of New York as he becomes the target
              of the world's most ruthless killers.
            </p>
            <div>
              <svg width="0" height="0">
                <filter id="filter">
                  <feTurbulence
                    type="fractalNoise"
                    baseFrequency=".01"
                    numOctaves="6"
                  />
                  <feDisplacementMap in="SourceGraphic" scale="100" />
                </filter>
              </svg>
              <div className={styles.btn4}>
                <div className={styles.button4}>
                  <span>Read More</span>
                  <div className={styles.back}></div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className={styles.card}>
          <img src={Book3} alt="book" />
          <div className={styles.descriptions}>
            <h1>E.JAVASCRIPT</h1>
            <p>
              After gunning down a member of the High Table -- the shadowy
              international assassin's guild -- legendary hit man John Wick
              finds himself stripped of the organization's protective services.
              Now stuck with a $14 million bounty on his head, Wick must fight
              his way through the streets of New York as he becomes the target
              of the world's most ruthless killers.
            </p>
            <div>
              <svg width="0" height="0">
                <filter id="filter">
                  <feTurbulence
                    type="fractalNoise"
                    baseFrequency=".01"
                    numOctaves="6"
                  />
                  <feDisplacementMap in="SourceGraphic" scale="100" />
                </filter>
              </svg>
              <div className={styles.btn4}>
                <div className={styles.button4}>
                  <span>Read More</span>
                  <div className={styles.back}></div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className={styles.card}>
          <img src={Book5} alt="book" />
          <div className={styles.descriptions}>
            <h1>HTML & CSS</h1>
            <p>
              After gunning down a member of the High Table -- the shadowy
              international assassin's guild -- legendary hit man John Wick
              finds himself stripped of the organization's protective services.
              Now stuck with a $14 million bounty on his head, Wick must fight
              his way through the streets of New York as he becomes the target
              of the world's most ruthless killers.
            </p>
            <div>
              <svg width="0" height="0">
                <filter id="filter">
                  <feTurbulence
                    type="fractalNoise"
                    baseFrequency=".01"
                    numOctaves="6"
                  />
                  <feDisplacementMap in="SourceGraphic" scale="100" />
                </filter>
              </svg>
              <div className={styles.btn4}>
                <div className={styles.button4}>
                  <span>Read More</span>
                  <div className={styles.back}></div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className={styles.card}>
          <img src={Book6} alt="book" />
          <div className={styles.descriptions}>
            <h1>JAVASCRIPT</h1>
            <p>
              After gunning down a member of the High Table -- the shadowy
              international assassin's guild -- legendary hit man John Wick
              finds himself stripped of the organization's protective services.
              Now stuck with a $14 million bounty on his head, Wick must fight
              his way through the streets of New York as he becomes the target
              of the world's most ruthless killers.
            </p>
            <div>
              <svg width="0" height="0">
                <filter id="filter">
                  <feTurbulence
                    type="fractalNoise"
                    baseFrequency=".01"
                    numOctaves="6"
                  />
                  <feDisplacementMap in="SourceGraphic" scale="100" />
                </filter>
              </svg>
              <div className={styles.btn4}>
                <div className={styles.button4}>
                  <span>Read More</span>
                  <div className={styles.back}></div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className={styles.card}>
          <img src={Book2} alt="book" />
          <div className={styles.descriptions}>
            <h1>REACT.JS</h1>
            <p>
              After gunning down a member of the High Table -- the shadowy
              international assassin's guild -- legendary hit man John Wick
              finds himself stripped of the organization's protective services.
              Now stuck with a $14 million bounty on his head, Wick must fight
              his way through the streets of New York as he becomes the target
              of the world's most ruthless killers.
            </p>
            <div>
              <svg width="0" height="0">
                <filter id="filter">
                  <feTurbulence
                    type="fractalNoise"
                    baseFrequency=".01"
                    numOctaves="6"
                  />
                  <feDisplacementMap in="SourceGraphic" scale="100" />
                </filter>
              </svg>
              <div className={styles.btn4}>
                <div className={styles.button4}>
                  <span>Read More</span>
                  <div className={styles.back}></div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className={styles.card}>
          <img src={Book1} alt="book" />
          <div className={styles.descriptions}>
            <h1>PROGRAMMING</h1>
            <p>
              After gunning down a member of the High Table -- the shadowy
              international assassin's guild -- legendary hit man John Wick
              finds himself stripped of the organization's protective services.
              Now stuck with a $14 million bounty on his head, Wick must fight
              his way through the streets of New York as he becomes the target
              of the world's most ruthless killers.
            </p>
            <div>
              <svg width="0" height="0">
                <filter id="filter">
                  <feTurbulence
                    type="fractalNoise"
                    baseFrequency=".01"
                    numOctaves="6"
                  />
                  <feDisplacementMap in="SourceGraphic" scale="100" />
                </filter>
              </svg>
              <div className={styles.btn4}>
                <div className={styles.button4}>
                  <span>Read More</span>
                  <div className={styles.back}></div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className={styles.card}>
          <img src={Book6} alt="book" />
          <div className={styles.descriptions}>
            <h1>JAVASCRIPT</h1>
            <p>
              After gunning down a member of the High Table -- the shadowy
              international assassin's guild -- legendary hit man John Wick
              finds himself stripped of the organization's protective services.
              Now stuck with a $14 million bounty on his head, Wick must fight
              his way through the streets of New York as he becomes the target
              of the world's most ruthless killers.
            </p>
            <div>
              <svg width="0" height="0">
                <filter id="filter">
                  <feTurbulence
                    type="fractalNoise"
                    baseFrequency=".01"
                    numOctaves="6"
                  />
                  <feDisplacementMap in="SourceGraphic" scale="100" />
                </filter>
              </svg>
              <div className={styles.btn4}>
                <div className={styles.button4}>
                  <span>Read More</span>
                  <div className={styles.back}></div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className={styles.card}>
          <img src={Book3} alt="book" />
          <div className={styles.descriptions}>
            <h1>E.JAVASCRIPT</h1>
            <p>
              After gunning down a member of the High Table -- the shadowy
              international assassin's guild -- legendary hit man John Wick
              finds himself stripped of the organization's protective services.
              Now stuck with a $14 million bounty on his head, Wick must fight
              his way through the streets of New York as he becomes the target
              of the world's most ruthless killers.
            </p>
            <div>
              <svg width="0" height="0">
                <filter id="filter">
                  <feTurbulence
                    type="fractalNoise"
                    baseFrequency=".01"
                    numOctaves="6"
                  />
                  <feDisplacementMap in="SourceGraphic" scale="100" />
                </filter>
              </svg>
              <div className={styles.btn4}>
                <div className={styles.button4}>
                  <span>Read More</span>
                  <div className={styles.back}></div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className={styles.card}>
          <img src={Book5} alt="book" />
          <div className={styles.descriptions}>
            <h1>HTML & CSS</h1>
            <p>
              After gunning down a member of the High Table -- the shadowy
              international assassin's guild -- legendary hit man John Wick
              finds himself stripped of the organization's protective services.
              Now stuck with a $14 million bounty on his head, Wick must fight
              his way through the streets of New York as he becomes the target
              of the world's most ruthless killers.
            </p>
            <div>
              <svg width="0" height="0">
                <filter id="filter">
                  <feTurbulence
                    type="fractalNoise"
                    baseFrequency=".01"
                    numOctaves="6"
                  />
                  <feDisplacementMap in="SourceGraphic" scale="100" />
                </filter>
              </svg>
              <div className={styles.btn4}>
                <div className={styles.button4}>
                  <span>Read More</span>
                  <div className={styles.back}></div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className={styles.card}>
          <img src={Book6} alt="book" />
          <div className={styles.descriptions}>
            <h1>JAVASCRIPT</h1>
            <p>
              After gunning down a member of the High Table -- the shadowy
              international assassin's guild -- legendary hit man John Wick
              finds himself stripped of the organization's protective services.
              Now stuck with a $14 million bounty on his head, Wick must fight
              his way through the streets of New York as he becomes the target
              of the world's most ruthless killers.
            </p>
            <div>
              <svg width="0" height="0">
                <filter id="filter">
                  <feTurbulence
                    type="fractalNoise"
                    baseFrequency=".01"
                    numOctaves="6"
                  />
                  <feDisplacementMap in="SourceGraphic" scale="100" />
                </filter>
              </svg>
              <div className={styles.btn4}>
                <div className={styles.button4}>
                  <span>Read More</span>
                  <div className={styles.back}></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Bookbox;
